// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"ae3046d5","579":"8880c6d2"}[chunkId] + ".chunk.js";
};